<template>
  <div class="row">
    <div class="col-md-24">
      <label class="mb-1 d-inline-block">{{ 'Presentation Notes' | translate }}</label>
      <modal-info class="d-lg-none" :value="'presentation-notes'">
        <template slot="modal-content">
          <h2 class="h2 px-3 pt-3 text-center">
            {{ 'Presentation Notes: Included when outputting reports.' | translate }}
          </h2>
          <div class="row modal-bottom pb-3">
            <a
              href="#"
              class="btn-cancel-modal d-flex justify-content-center"
              data-dismiss="modal"
              >{{ 'Cancel' | translate }}</a
            >
          </div>
        </template>
      </modal-info>
      <modal-info :value="'presentation-notes-sm'" class="d-none d-lg-inline-block">
        <template slot="modal-content">
          <h2 class="h2 px-3 pt-3 pb-2 text-center">
            {{ 'Presentation Notes: Included when outputting reports.' | translate }}
          </h2>
          <div class="row modal-bottom pb-3">
            <a
              href="#"
              class="btn-cancel-modal d-flex justify-content-center"
              data-dismiss="modal"
              >{{ 'Cancel' | translate }}</a
            >
          </div>
        </template>
      </modal-info>
    </div>
    <div class="col-md-24">
      <textarea
        v-model="tempValue"
        v-on:input="$emit('input', $event.target.value)"
        rows="6"
        class="form-control d-none d-lg-block"
      ></textarea>
      <textarea
        v-model="tempValue"
        v-on:input="$emit('input', $event.target.value)"
        rows="4"
        class="form-control d-lg-none"
      ></textarea>
    </div>
  </div>
</template>

<script>
import ModalInfo from '@/components/misc/modal-info.vue';

export default {
  components: {
    ModalInfo,
  },
  data() {
    return {
      tempValue: this.$props.value,
    };
  },
  props: ['value'],
};
</script>
